class AppBank {
	data:{ [key: string]: string } = {};
	set(key:string,value:string){
		this.data[key] = value;
	}
	get(key:string){
		return this.data[key];
	}
	has(key:string){
		if( key in this.data ){
			return true;
		}
		return false;
	}
}
export default AppBank;